module.exports = __webpack_public_path__ + "img/no-ticket.710c2d18.svg";